import {
    BankOutlined,
    BellOutlined,
    ShareAltOutlined,
} from '@ant-design/icons';

export const menus = [
    {
        label: '我的推广',
        key: 'myPromotion',
        icon: <ShareAltOutlined />,
    },
    {
        label: '提现记录',
        key: 'withdrawRecords',
        icon: <BellOutlined />,
    },
    {
        label: '提现信息',
        key: 'withdrawInfo',
        icon: <BankOutlined />,
    },
];
